'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = require('../../lib/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'hiddenInput': 'Checkbox__hiddenInput___3fGAk',
  'container': 'Checkbox__container___2viz_',
  'label': 'Checkbox__label___2_a4i',
  'labelContainerDisabled': 'Checkbox__labelContainerDisabled___1mvHZ',
  'labelDisabled': 'Checkbox__labelDisabled___2iVhW',
  'children': 'Checkbox__children___3tJgD',
  'childrenDisabled': 'Checkbox__childrenDisabled___VMApn',
  'checkbox': 'Checkbox__checkbox___2gFBy',
  'checkboxUnchecked': 'Checkbox__checkboxUnchecked___2TvQ-',
  'checkmark': 'Checkbox__checkmark___ApF0J',
  'checkboxDisabled': 'Checkbox__checkboxDisabled___Ie3Mk',
  'checkboxChecked': 'Checkbox__checkboxChecked___3pdpQ'
};

var DefaultCheckbox = (0, _mergeThemeHoc2.default)(style)(_Checkbox2.default);
DefaultCheckbox.displayName = 'DefaultCheckbox';
exports.default = DefaultCheckbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/dist/Checkbox/index.js
// module id = ./node_modules/dibs-elements/dist/Checkbox/index.js
// module chunks = 4